import React, { useEffect, useState } from "react";
import MaterialLayout from "./components/Layout/MaterialLayout";
import AppointmentForm from "./components/AppointmentForm";

function App() {
  const [activeStepColor, setActiveStepColor] = useState("#FFFFFF");
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let schedTag = new URLSearchParams(window.location.search).get("schedtag");
    if (
      window.location.origin.indexOf("localhost") !== -1 ||
      window.location.origin.indexOf(
        "scheduler-frontend-dot-autobot-v1-356820.ue.r.appspot.com"
      ) !== -1 ||
      schedTag === "true"
    ) {
      setOpen(true);
    }
  }, []);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    window.parent.postMessage("closeIframe", "*");
    window.location.reload(); // Reload the entire app
  };

  function openScheduler() {
    handleOpen();

    // Implementation to open the React app
    // This can involve rendering the app in a container or showing/hiding relevant elements
  }

  // Attach the function to the window object to make it accessible globally
  window.openScheduler = openScheduler;

  return (
    <div
      style={{
        //  backgroundImage: `url(${process.env.PUBLIC_URL}imag.png)`,
        // backgroundColor: "#f5f5f5 !important",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        height: "100vh",
        /*background-position: 50% 50%; /* set your desired background color */
        /* set the height to 100% of the viewport height */
        margin: 0,
        fontFamily: "Poppins",
        minHeight: "100vh",
      }}
    >
      <MaterialLayout activeStepColor={activeStepColor} open={open}>
        <AppointmentForm
          setActiveStepColor={setActiveStepColor}
          handleClose={handleClose}
        />
      </MaterialLayout>
    </div>
  );
}

export default App;
